import { Box } from '@material-ui/core'
import { CheckCircleOutlineTwoTone } from '@material-ui/icons'
import { SUCCESS_COLORS } from 'asterX-UI'
import { AsterChip } from 'asterX-UI/Chip'
import { getValidDate } from 'lib/utils'

export const formatAmount = amount => (amount ? `${amount.toString().thousandSeparator()} ₸` : '-')

export const financeTableColumns = tableType => {
  switch (tableType) {
    case 'overdueTranches':
      return ['Вид суммы', 'Баланс', 'Дата погашения', 'Итого']
    case 'paymentSchedule':
      return ['№', 'Дата платежа', 'OC', 'Проценты', 'Штрафы', 'Итого', 'Льготный', 'Статус']
    case 'payments':
      return ['Акц', 'Дата', 'Тип ДДС', 'Сумма', 'Банк/Касса', 'Номер ордера']
    case 'detailedLayout':
      return ['Дата', 'Документ', 'Сумма', 'Вид платежа', 'Вид суммы', 'Вид движения']
    case 'periodicDetails':
      return ['Дата', 'Тип', 'Значение']

    default:
      return []
  }
}

export const financeTableRows = (tableType, data) => {
  if (!data) {
    return []
  }

  switch (tableType) {
    case 'overdueTranches':
      return data.map(item => [
        item?.nameAmountType,
        formatAmount(item?.overdueAmount),
        getValidDate(item?.repaymentDate),
        formatAmount(item?.overdueAmount)
      ])

    case 'paymentSchedule':
      return data.map((item, index) => [
        index + 1,
        getValidDate(item?.repaymentDate),
        formatAmount(item?.principal),
        formatAmount(item?.interest),
        formatAmount(item?.penalty),
        formatAmount(item?.total),
        item?.lgot ? (
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleOutlineTwoTone style={{ color: SUCCESS_COLORS[600], fontSize: 20 }} />
          </Box>
        ) : (
          '-'
        ),
        item?.paid ? (
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleOutlineTwoTone style={{ color: SUCCESS_COLORS[600], fontSize: 20 }} />
          </Box>
        ) : (
          '-'
        )
      ])

    case 'payments':
      return data.map(item => [
        '-',
        getValidDate(item?.operationDate, true),
        <AsterChip label={item?.ddsType} color={item?.ddsType === 'Приход' ? 'greenOut' : 'redOut'} />,
        formatAmount(item?.amountLocalCur),
        item?.paymentPointName || '-',
        item?.contractId || '-'
      ])
    case 'detailedLayout':
      return data.map(item => [
        getValidDate(item?.operationDate, true),
        item?.documentName || '-',
        formatAmount(item?.amountLocalCurrency),
        item?.paymentName || '-',
        item?.amountName || '-',
        item?.actionName || '-'
      ])

    case 'periodicDetails':
      return data.map(item => [
        getValidDate(item?.operationDate),
        item?.type,
        <AsterChip label={item?.value} color={item?.value === 'Возобновлено' ? 'greenOut' : 'redOut'} />
      ])

    default:
      return []
  }
}

const sumOverdueTranches = data => {
  if (!data) {
    return []
  }

  const groupedData = data.reduce((acc, item) => {
    const nameAmountType = item?.nameAmountType || ''
    const overdueAmount = parseFloat(item?.overdueAmount) || 0

    if (!acc[nameAmountType]) {
      acc[nameAmountType] = 0
    }

    acc[nameAmountType] += overdueAmount
    return acc
  }, {})

  return Object.entries(groupedData).map(([nameAmountType, totalOverdueAmount]) => {
    return { nameAmountType, overdueAmount: totalOverdueAmount }
  })
}

export const resultOverdueTranchesRows = data => {
  if (!data) {
    return []
  }
  const resultData = sumOverdueTranches(data)

  return resultData.map(item => [
    item?.nameAmountType,
    formatAmount(item?.overdueAmount),
    formatAmount(item?.overdueAmount)
  ])
}
